import type { ReactNode } from 'react';

import styles from './FieldGroup.module.css';

export interface FieldGroupProps {
  /** The group's heading, e.g. "Name" or "Next of kin". Sentence case. */
  legend: string;
  /** One line under the heading. */
  description?: string;
  /** A problem with the group as a whole, e.g. "Add at least one name." */
  errorMessage?: string;
  children: ReactNode;
}

/**
 * A titled group of related fields in a form (a `fieldset`), so screen readers announce
 * the heading with each field in it. Groups are separated by space, not boxes.
 */
export function FieldGroup({ legend, description, errorMessage, children }: FieldGroupProps) {
  return (
    <fieldset
      className={styles.group}
      data-invalid={errorMessage === undefined ? undefined : true}
      {...(errorMessage === undefined ? {} : { 'aria-invalid': true })}
    >
      <legend className={styles.legend}>{legend}</legend>
      {description === undefined ? null : <p className={styles.description}>{description}</p>}
      {errorMessage === undefined ? null : (
        <p className={styles.error} role="alert">
          {errorMessage}
        </p>
      )}
      <div className={styles.fields}>{children}</div>
    </fieldset>
  );
}
